import pushApi from "restApi/pushApi";

// pushManager.subscribe() wants the VAPID public key as a raw Uint8Array,
// not the base64url string GetAppConfig hands back.
const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
};

export const isPushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

// One of: "unsupported" (this browser can't do push at all - older
// Safari, some in-app browsers), "denied" (the user said no at the OS/
// browser level - can't be re-prompted from here, only from the
// browser's own site settings), "subscribed", "not-subscribed".
export const getPushStatus = async () => {
  if (!isPushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  return subscription ? "subscribed" : "not-subscribed";
};

export const enablePushNotifications = async (vapidPublicKey) => {
  if (!isPushSupported()) {
    throw new Error("Push notifications aren't supported in this browser.");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Notification permission was not granted.");
  }
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
  });
  await pushApi.saveSubscription(subscription.toJSON());
  return subscription;
};

export const disablePushNotifications = async () => {
  if (!isPushSupported()) return;
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;
  const endpoint = subscription.endpoint;
  await subscription.unsubscribe();
  await pushApi.deleteSubscription(endpoint);
};
